import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-[#FAF8F5]" data-id="element-140">
      <div className="max-w-4xl mx-auto px-4 py-16" data-id="element-141">
        <Link to="/" className="inline-flex items-center text-[#C9A227] hover:text-[#3D2314] transition-colors mb-8" data-id="element-142">
          <ArrowLeft className="w-5 h-5 mr-2" data-id="element-143" />
          Volver a la página principal
        </Link>

        <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#3D2314] mb-8" data-id="element-144">
          Política de Privacidad
        </h1>

        <div className="prose prose-lg max-w-none text-[#5C3D2E]" data-id="element-145">
          <p className="text-sm text-[#5C3D2E]/70 mb-8" data-id="element-146">
            Última actualización: Enero 2025
          </p>

          <section className="mb-10" data-id="element-147">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-148">
              1. Responsable del Tratamiento
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-149">
              El responsable del tratamiento de los datos personales es{' '}
              <strong data-id="element-150">Digital Audible Editorial</strong>.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-151">
              La venta y entrega de los productos digitales se realiza a través
              de la plataforma <strong data-id="element-152">Hotmart</strong>, que actúa como
              encargado del tratamiento para la gestión de pagos y entrega de
              contenidos.
            </p>
            <p className="leading-relaxed" data-id="element-153">
              Esta página web está alojada en <strong data-id="element-154">MagicPatterns</strong>.
            </p>
          </section>

          <section className="mb-10" data-id="element-155">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-156">
              2. Datos que Recopilamos
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-157">
              Recopilamos los siguientes datos personales:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-158">
              <li data-id="element-159">Nombre y apellidos</li>
              <li data-id="element-160">Dirección de correo electrónico</li>
              <li data-id="element-161">Datos de facturación (procesados por Hotmart)</li>
              <li data-id="element-162">Datos de navegación y cookies</li>
            </ul>
          </section>

          <section className="mb-10" data-id="element-163">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-164">
              3. Finalidad del Tratamiento
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-165">
              Sus datos personales serán tratados para:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-166">
              <li data-id="element-167">Gestionar la compra y entrega de los productos digitales</li>
              <li data-id="element-168">Enviar comunicaciones relacionadas con su compra</li>
              <li data-id="element-169">Atender sus consultas y solicitudes</li>
              <li data-id="element-170">Cumplir con las obligaciones legales aplicables</li>
              <li data-id="element-171">
                Enviar información comercial (solo con su consentimiento previo)
              </li>
            </ul>
          </section>

          <section className="mb-10" data-id="element-172">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-173">
              4. Base Legal del Tratamiento
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-174">
              El tratamiento de sus datos se basa en:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-175">
              <li data-id="element-176">
                <strong data-id="element-177">Ejecución de un contrato:</strong> para la gestión de su
                compra
              </li>
              <li data-id="element-178">
                <strong data-id="element-179">Consentimiento:</strong> para el envío de comunicaciones
                comerciales
              </li>
              <li data-id="element-180">
                <strong data-id="element-181">Interés legítimo:</strong> para mejorar nuestros
                servicios
              </li>
              <li data-id="element-182">
                <strong data-id="element-183">Obligación legal:</strong> para cumplir con la normativa
                fiscal y mercantil
              </li>
            </ul>
          </section>

          <section className="mb-10" data-id="element-184">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-185">
              5. Destinatarios de los Datos
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-186">
              Sus datos podrán ser comunicados a:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-187">
              <li data-id="element-188">
                <strong data-id="element-189">Hotmart:</strong> para la gestión de pagos y entrega de
                productos
              </li>
              <li data-id="element-190">
                <strong data-id="element-191">Proveedores de servicios:</strong> que nos asisten en la
                prestación del servicio
              </li>
              <li data-id="element-192">
                <strong data-id="element-193">Administraciones públicas:</strong> cuando sea requerido
                por ley
              </li>
            </ul>
          </section>

          <section className="mb-10" data-id="element-194">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-195">
              6. Transferencias Internacionales
            </h2>
            <p className="leading-relaxed" data-id="element-196">
              Hotmart puede transferir datos fuera del Espacio Económico
              Europeo. En tales casos, se garantiza que existen las salvaguardas
              adecuadas conforme al RGPD, incluyendo cláusulas contractuales
              tipo aprobadas por la Comisión Europea.
            </p>
          </section>

          <section className="mb-10" data-id="element-197">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-198">
              7. Conservación de los Datos
            </h2>
            <p className="leading-relaxed" data-id="element-199">
              Sus datos se conservarán durante el tiempo necesario para cumplir
              con la finalidad para la que fueron recogidos y para determinar
              las posibles responsabilidades derivadas de dicha finalidad. Los
              datos de facturación se conservarán durante el plazo legal
              establecido (mínimo 6 años según la normativa mercantil española).
            </p>
          </section>

          <section className="mb-10" data-id="element-200">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-201">
              8. Sus Derechos
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-202">
              Conforme al RGPD y la LOPDGDD, usted tiene derecho a:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-203">
              <li data-id="element-204">
                <strong data-id="element-205">Acceso:</strong> conocer qué datos personales tratamos
                sobre usted
              </li>
              <li data-id="element-206">
                <strong data-id="element-207">Rectificación:</strong> corregir datos inexactos o
                incompletos
              </li>
              <li data-id="element-208">
                <strong data-id="element-209">Supresión:</strong> solicitar la eliminación de sus
                datos
              </li>
              <li data-id="element-210">
                <strong data-id="element-211">Oposición:</strong> oponerse al tratamiento de sus datos
              </li>
              <li data-id="element-212">
                <strong data-id="element-213">Limitación:</strong> solicitar la limitación del
                tratamiento
              </li>
              <li data-id="element-214">
                <strong data-id="element-215">Portabilidad:</strong> recibir sus datos en formato
                estructurado
              </li>
              <li data-id="element-216">
                <strong data-id="element-217">Retirar el consentimiento:</strong> en cualquier momento
              </li>
            </ul>
            <p className="leading-relaxed" data-id="element-218">
              Para ejercer estos derechos, puede contactarnos a través de los
              canales indicados. También tiene derecho a presentar una
              reclamación ante la Agencia Española de Protección de Datos
              (www.aepd.es).
            </p>
          </section>

          <section className="mb-10" data-id="element-219">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-220">
              9. Cookies
            </h2>
            <p className="leading-relaxed" data-id="element-221">
              Esta web utiliza cookies propias y de terceros para mejorar la
              experiencia de navegación y analizar el uso del sitio. Puede
              configurar sus preferencias de cookies en cualquier momento a
              través de la configuración de su navegador.
            </p>
          </section>

          <section data-id="element-222">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-223">
              10. Modificaciones
            </h2>
            <p className="leading-relaxed" data-id="element-224">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              para adaptarla a novedades legislativas o jurisprudenciales. Los
              cambios serán publicados en esta página con indicación de la fecha
              de última actualización.
            </p>
          </section>
        </div>
      </div>

      <footer className="bg-[#2A180D] text-[#E0D8D0] py-8 text-center border-t border-[#3D2314]" data-id="element-225">
        <div className="max-w-7xl mx-auto px-4" data-id="element-226">
          <p className="text-sm opacity-60" data-id="element-227">
            © 2024 Digital Audible Editorial. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}